var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.664 0.252601C18.0768 0.619519 18.1139 1.25159 17.747 1.66437L7.08036 13.6644C6.89059 13.8779 6.61858 14 6.33295 14C6.04731 14 5.7753 13.8779 5.58554 13.6644L0.916466 9.41177C0.549548 8.99899 0.586729 8.36692 0.999512 8C1.41229 7.63308 2.04437 7.67026 2.41128 8.08305L6.33295 11.4948L16.2522 0.335647C16.6191 -0.077136 17.2512 -0.114317 17.664 0.252601Z",
    fill: "#4AC600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck);
export default __webpack_public_path__ + "static/media/green_check.4584620b4c5f20b40d7cdefd2f93c5e1.svg";
export { ForwardRef as ReactComponent };